<selfai-platform-user-function
  [userFunctions]="userFunctions$ | async"
  [workflows]="workflows$ | async"
  [namespaces]="namespaces$ | async"
  [tags]="tags$ | async"
  (backEvent)="onBack()"
  (submitEvent)="onSubmit($event)"
></selfai-platform-user-function>
